import React from 'react';

const SvgBo = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BO_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BO_svg__b" fill="#fff">
        <use xlinkHref="#BO_svg__a" />
      </mask>
      <use fill="#FFF" xlinkHref="#BO_svg__a" />
      <path fill="#058C3F" mask="url(#BO_svg__b)" d="M0 13.333h28V20H0z" />
      <path fill="#E63426" mask="url(#BO_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#FFEB1F" mask="url(#BO_svg__b)" d="M0 6.667h28v6.667H0z" />
    </g>
  </svg>
);

export default SvgBo;
